export default __webpack_public_path__ + "static/media/Women_Dog.820df555.png";